import { render, staticRenderFns } from "./CultureAssetDisposeAudit.vue?vue&type=template&id=0c33a670&scoped=true&"
import script from "./CultureAssetDisposeAudit.vue?vue&type=script&lang=js&"
export * from "./CultureAssetDisposeAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c33a670",
  null
  
)

export default component.exports